import React from "react";
import DataSection from "../components/sections/Data.jsx";
import SliderSection from "../components/sections/Slider.jsx";
import { data } from "../constants/mynet/data.js";
import { icerikler } from "../constants/mynet/icerikler.js";
import { projeler } from "../constants/mynet/projeler.js";
import { vitrin } from "../constants/mynet/vitrin.js";
import { display } from "../constants/mynet/display.js";
import { useLanguage } from "../contexts/LanguageContext";

export default function Mynet() {
  const { language } = useLanguage();

  return (
    <div className="flex flex-col">
      <img
        src={
          language === "TR"
            ? "https://srv-cdn.onedio.com/store/e3cb034d289ea900e0daa3e857c53e880e74dbef133f52b77d9a2ede30d0bbdb.png"
            : "https://srv-cdn.onedio.com/store/b0df6dcefc8695be1f02bdf2fb22ca0ef48589fb47adfd76a2a1dcd73f92557a.png"
        }
        className="w-full max-w-[1440px] mx-auto"
        alt=""
      />
      <DataSection data={data} title="Datalar" name="datalar" />
      <SliderSection
        className={"bg-[#FBFBFB]"}
        data={icerikler}
        circle={true}
        name="icerikler"
      />
      <SliderSection
        className={"bg-[#FEF9F3]"}
        data={projeler}
        circle={false}
        name="projeler"
      />
      <SliderSection
        className={"bg-[#ffefdd]"}
        data={vitrin}
        circle={false}
        name="vitrin"
      />
      <SliderSection
        className={"bg-[#ffefdd]"}
        data={display}
        circle={false}
        name="display"
      />
    </div>
  );
}
